import { basicPlan, standardPlan, annualPlan } from '../../price-table/constants'

const isUpgrading = (subscription, upcomingSubscription) => {
  if (!subscription || !upcomingSubscription) return false

  // Order from lowest to highest
  const order = [basicPlan.sku, standardPlan.sku, annualPlan.sku]

  // Example: upcoming subscription is annual and current subscription is standard
  // Then it return 2 > 1 which is true
  return order.indexOf(upcomingSubscription.sku) > order.indexOf(subscription.sku)
}

export default isUpgrading
